import { useNavigate } from 'react-router-dom';

export type ButtonsProps = React.HTMLAttributes<HTMLDivElement> & {
	id: string;
};

export const Buttons: React.FC<ButtonsProps> = ({
	id,
	className,
	...props
}) => {
	const navigate = useNavigate();

	return (
		<div
			className={`align-items-stretch my-2 order-card-buttons${
				className ? ` ${className}` : ''
			}`}
			{...props}
		>
			<button
				style={{
					minWidth: 150
				}}
				className="btn btn-primary d-block d-ms-inline-block w-100 w-ms-auto mr-0 mb-1 mr-ms-1 mb-ms-0"
				onClick={() => navigate(`/account/orders/${id}`)}
			>
				Details
			</button>
		</div>
	);
};
